export default __webpack_public_path__ + "static/media/checkers-3-rMAX.b3e0ee1c.jpg";